module.exports = __webpack_public_path__ + "static/media/fort_collins_team.1be9ece5.jpg";